import { makeStyles, Theme } from '@mui/styles'
import { GridSpacing } from '@mui/material'

interface GridContainerStyleProps {
  gridSpacing: GridSpacing
}

export const useGridContainerStyles = makeStyles<Theme, GridContainerStyleProps>((theme) => ({
  gridContainer: {
    padding: theme.spacing(3),
    paddingLeft: ({ gridSpacing }) => theme.spacing(gridSpacing) / 2,
    paddingRight: ({ gridSpacing }) => theme.spacing(gridSpacing) / 2,
  },
  innerGridContainer: {
    paddingTop: ({ gridSpacing }) => theme.spacing(gridSpacing) / 4,
    paddingBottom: ({ gridSpacing }) => theme.spacing(gridSpacing) / 4,
    paddingLeft: ({ gridSpacing }) => theme.spacing(gridSpacing) / 2,
    paddingRight: ({ gridSpacing }) => theme.spacing(gridSpacing) / 2,
  },
  maxWidthXs: {
    maxWidth: Math.max(theme.breakpoints.values.xs, 444),
  },
  maxWidthSm: {
    maxWidth: theme.breakpoints.values.sm,
  },
  maxWidthMd: {
    maxWidth: theme.breakpoints.values.md,
  },
  centerForm: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  // /* Styles applied to the root element if `maxWidth="xs"`. */
  // maxWidthXs: (0, _defineProperty2.default)({}, theme.breakpoints.up('xs'), {
  //   maxWidth: Math.max(theme.breakpoints.values.xs, 444)
  // }),
  //
  // /* Styles applied to the root element if `maxWidth="sm"`. */
  // maxWidthSm: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
  //   maxWidth: theme.breakpoints.values.sm
  // }),
  //
  // /* Styles applied to the root element if `maxWidth="md"`. */
  // maxWidthMd: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
  //   maxWidth: theme.breakpoints.values.md
  // }),
  //
  // /* Styles applied to the root element if `maxWidth="lg"`. */
  // maxWidthLg: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
  //   maxWidth: theme.breakpoints.values.lg
  // }),
  //
  // /* Styles applied to the root element if `maxWidth="xl"`. */
  // maxWidthXl: (0, _defineProperty2.default)({}, theme.breakpoints.up('xl'), {
  //   maxWidth: theme.breakpoints.values.xl
  // })
}))

// when adding spacing top / bottom we actually override the padding
// which is set by the parent grid 'spacing' prop
// additionally we would have to remove the negative margin which is added at the same time
// improvement proposal -- make the use of 'spacingTop' and 'spacingBottom' more clear / simpler
export interface RowStyleProps {
  spacingTop?: GridSpacing
  spacingBottom?: GridSpacing
  spacingHorizontal?: GridSpacing
}

export interface ColStyleProps {
  spacingHorizontal?: GridSpacing
}

export const useRowStyles = makeStyles<Theme, RowStyleProps>((theme) => {
  return {
    spacingTop: {
      paddingTop: ({ spacingTop }) => theme.spacing(
        (spacingTop !== undefined)
          ? spacingTop
          : 0,
      ) / 2 + 'px !important',
    },
    spacingHorizontal: {
      paddingLeft: ({ spacingHorizontal }) => theme.spacing(
        (spacingHorizontal !== undefined)
          ? spacingHorizontal
          : 0,
      ) + 'px !important',
      paddingRight: ({ spacingHorizontal }) => theme.spacing(
        (spacingHorizontal !== undefined)
          ? spacingHorizontal
          : 0,
      ) + 'px !important',
    },
    spacingBottom: {
      paddingBottom: ({ spacingBottom }) => theme.spacing(
        (spacingBottom !== undefined)
          ? spacingBottom
          : 3,
      ) / 2 + 'px !important',
    },
  }
})

export const useColStyles = makeStyles<Theme, ColStyleProps>((theme) => {
  return {
    spacingHorizontal: {
      paddingLeft: ({ spacingHorizontal }) => theme.spacing(
        (spacingHorizontal !== undefined)
          ? spacingHorizontal
          : 0,
      ) / 4 + 'px !important',
      paddingRight: ({ spacingHorizontal }) => theme.spacing(
        (spacingHorizontal !== undefined)
          ? spacingHorizontal
          : 0,
      ) / 4 + 'px !important',
      paddingTop: ({ spacingHorizontal }) => theme.spacing(
        (spacingHorizontal !== undefined)
          ? spacingHorizontal
          : 0,
      ) / 4 + 'px !important',
      paddingBottom: ({ spacingHorizontal }) => theme.spacing(
        (spacingHorizontal !== undefined)
          ? spacingHorizontal
          : 0,
      ) / 4 + 'px !important',
    },
  }
})
